import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  spacing = tokens.spacing;
var mini = designTokenFonts.mini;
export var container = {
  name: "13o7eu2",
  styles: "display:block;"
};
export var cardContainer = /*#__PURE__*/css("display:flex;flex-direction:row;gap:", spacing.xs, ";overflow:auto hidden;-ms-overflow-style:none;scrollbar-width:none;::-webkit-scrollbar{display:none;}");
export var message = /*#__PURE__*/css(mini, ";color:", colors.interactive.base.default, ";");